(() => {
  const FORM_ID = 'ae42564c-485e-43e6-ab2a-b5652e123077';
  const CONTACT_PATH = '/pages/contact-us';
  const EMBED_URL = 'https://js-eu1.hsforms.net/forms/embed/143503238.js';

  function sourcePath(value) {
    if (typeof value !== 'string' || value.length > 2048 || /[\\\u0000-\u001f\u007f]/.test(value)) return null;
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      if (!/^\/(?:products\/[a-z0-9-]+|collections\/[a-z0-9-]+|pages\/[a-z0-9-]+|cart|search)?\/?$/.test(url.pathname)) return null;
      return url.pathname;
    } catch {
      return null;
    }
  }

  function addInquiryContext(event) {
    const link = event.target?.closest?.('a[href]');
    if (!link) return;
    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch {
      return;
    }
    if (url.origin !== window.location.origin || url.pathname !== CONTACT_PATH) return;
    const existing = sourcePath(url.searchParams.get('from'));
    url.searchParams.set('from', existing || sourcePath(window.location.pathname) || '/');
    url.hash = 'contact-form';
    link.href = url.href;
  }

  document.addEventListener('click', addInquiryContext);
  document.addEventListener('auxclick', addInquiryContext);

  const section = document.querySelector('[data-hubspot-contact]');
  if (!section) return;
  const status = section.querySelector('[data-form-status]');
  const loadButton = section.querySelector('[data-form-load]');
  const template = section.querySelector('[data-form-template]');
  const container = section.querySelector('[data-form-container]');
  if (!status || !loadButton || !template || !container) return;
  loadButton.hidden = false;
  const requestedSource = new URLSearchParams(window.location.search).get('from');
  const contextPath = sourcePath(requestedSource) || CONTACT_PATH;
  let readyInstance = null;
  let ready = false;
  let requested = false;
  let loadTimeout = null;

  function showFallback() {
    if (ready) return;
    status.textContent = status.dataset.unavailable;
    status.hidden = false;
  }

  window.addEventListener('hs-form-event:on-ready', (event) => {
    if (!requested) return;
    const detail = event.detail;
    if (detail?.formId !== FORM_ID || typeof detail.instanceId !== 'string' || !detail.instanceId) return;
    if (readyInstance && readyInstance !== detail.instanceId) return;
    try {
      const form = window.HubSpotFormsV4?.getFormFromEvent(event);
      if (form?.getFormId() !== FORM_ID || form.getInstanceId() !== detail.instanceId) return;
      readyInstance = detail.instanceId;
      ready = true;
      status.hidden = true;
      window.clearTimeout(loadTimeout);
      Promise.resolve(form.setFieldValue('0-1/shopify_source_page', [contextPath])).catch(() => {});
    } catch {
      // The form remains available if optional inquiry context cannot be set.
    }
  });

  loadButton.addEventListener('click', () => {
    if (requested) return;
    requested = true;
    loadButton.hidden = true;
    status.hidden = false;
    container.append(template.content.cloneNode(true));
    loadTimeout = window.setTimeout(showFallback, 12000);
    if (!document.getElementById('tilibit-hubspot-embed')) {
      const embed = document.createElement('script');
      embed.id = 'tilibit-hubspot-embed';
      embed.src = EMBED_URL;
      embed.async = true;
      embed.addEventListener('error', showFallback);
      document.head.append(embed);
    }
  });
})();
